const userTypes = {
  guest: 'guest',
  registerUser: 'registerUser',
};

export default userTypes;
